import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/withdrawal"

export const getWithdrawals = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const createWithdrawalRequest = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const changeWithdrawalStatus = async (withdrawalId, status, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/result/${withdrawalId}/${status}`, data)

  return response.data
}